var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mode == "bar"
    ? _c("div", [
        _c(
          "div",
          { staticClass: "wrapper-semaforo con-ombra" },
          [
            _vm.buttons.includes("play")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "secondary white--text ma-0 px-2 btn-avvia",
                    attrs: {
                      small: "",
                      rounded: "",
                      depressed: "",
                      disabled: !(
                        (_vm.asta_info.counter > 0 || _vm.premium) &&
                        !_vm.isAstaInCorso
                      ),
                    },
                    on: { click: _vm.avviaAsta },
                  },
                  [
                    _c(
                      "v-icon",
                      { attrs: { small: "", light: "", left: "" } },
                      [_vm._v("play_arrow")]
                    ),
                    _vm._v("\n      Avvia\n    "),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.buttons.includes("stop")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "red lighten-1 white--text ma-0",
                    class: { "px-2": !_vm.is_mobile },
                    attrs: {
                      small: "",
                      rounded: !_vm.is_mobile,
                      icon: _vm.is_mobile,
                      depressed: "",
                      disabled: !_vm.isAstaInCorso,
                    },
                    on: { click: _vm.fermaAsta },
                  },
                  [
                    _c(
                      "v-icon",
                      { attrs: { small: "", light: "", left: !_vm.is_mobile } },
                      [_vm._v("stop")]
                    ),
                    _vm._v(" "),
                    !_vm.is_mobile ? _c("span", [_vm._v("Stop")]) : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }